export var EventSubscriptionType = /*#__PURE__*/ function(EventSubscriptionType) {
    EventSubscriptionType["BACK_IN_STOCK"] = "BACK_IN_STOCK";
    return EventSubscriptionType;
}({});
